import { useEffect, useMemo, useState } from 'react';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { PAYMENT_TYPE, useStores } from '~/utils';
import CreditSimulationBankAccount from './CreditSimulationBankAccount';
import {
  type CreditSimulationBankAccountFormValues,
  initialValues,
  validationSchema,
} from './schema';

const CreditSimulationBankAccountContainer = () => {
  const [banks, setBanks] = useState<Banks[]>([]);
  const { creditProducts } = useStores();
  const navigate = useNavigate();

  const bankOptions = useMemo(
    () =>
      banks.map((bank) => ({
        value: bank.code,
        label: bank.name,
      })),
    [banks],
  );

  const onSubmit = async (values: CreditSimulationBankAccountFormValues) => {
    creditProducts.setCurrentCreditSimulationRequest({
      account: values.account,
      agency: values.agency,
      bankNumber: values.bank,
      paymentType: PAYMENT_TYPE.TRANSFER,
      accountDigit: values.accountDigit,
      agencyDigit: values.agencyDigit,
    });
    await creditProducts.creditSimulation();
    navigate(Routes.CREDIT_SIMULATION_CONFIRMATION);
  };

  useEffect(() => {
    const fetchBanks = async () => {
      const banks = await creditProducts.getBanks();
      setBanks(banks);
    };
    fetchBanks();
  }, []);

  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <CreditSimulationBankAccount banks={bankOptions} />
    </FormBehavior>
  );
};

export default observer(CreditSimulationBankAccountContainer);
